import { CreateEvent, CreateEventMutation, CreateEventMutationVariables } from 'generated/graphql'
import gql from 'graphql-tag'
import graphql from 'utils/graphql'

const createEventMutation = gql`
    mutation CreateEvent($data: CreateEvent!) {
        createEvent(data: $data) {
            id
            slug
        }
    }
`
export const createEvent = (data: CreateEvent) => graphql.createQuery<
    CreateEventMutation, CreateEventMutationVariables
>(createEventMutation)({ data })
